// Minimal shim for `aria-hidden` to avoid build-time resolver issues in Vercel.
// Provides a no-op implementation of `hideOthers` that returns a cleanup function.

export function hideOthers(..._elements: Array<Element>): () => void {
  return () => {
    // no-op cleanup
  }
}

export default {
  hideOthers,
}


